import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeoutTemplate"]
  static values = {
    url: String,
    intervalMs: { type: Number, default: 1500 },
    maxAttempts: { type: Number, default: 200 },
    startDelayMs: { type: Number, default: 500 }
  }

  connect() {
    this.attempts = 0
    this.timer = setTimeout(() => this.poll(), this.startDelayMsValue)
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  async poll() {
    if (this.attempts++ >= this.maxAttemptsValue) {
      this.renderTimeout()
      return
    }
    try {
      const r = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
      if (r.ok) {
        const d = await r.json()
        if (d.status === "ready" && d.html) {
          this.element.innerHTML = d.html
          return
        }
      }
    } catch (e) { /* network blip — just retry */ }
    this.timer = setTimeout(() => this.poll(), this.intervalMsValue)
  }

  renderTimeout() {
    if (this.hasTimeoutTemplateTarget) {
      this.element.innerHTML = this.timeoutTemplateTarget.innerHTML
    }
  }
}
